const DECK_KEY = "dst_deck";
const COMPS_KEY = "dst_compositions";
const TOTAL_SEEN_KEY = "dst_total_unpacked_seen";

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return fallback;
    return JSON.parse(raw);
  } catch { return fallback; }
}
function writeJson(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
}

export function loadDeck() {
  return readJson(DECK_KEY, { action: {}, observation: {}, relation: {} });
}
export function saveDeck(deck) { writeJson(DECK_KEY, deck); }

export function addCardsToDeck(cards) {
  const deck = loadDeck();
  for (const c of cards) {
    deck[c.suit] = deck[c.suit] || {};
    deck[c.suit][c.index] = (deck[c.suit][c.index] || 0) + 1;
  }
  saveDeck(deck);
  return deck;
}

export function loadCompositions() {
  return readJson(COMPS_KEY, []);
}
export function saveComposition(comp) {
  const all = loadCompositions();
  const idx = all.findIndex((c) => c.id === comp.id);
  if (idx >= 0) all[idx] = comp;
  else all.push(comp);
  writeJson(COMPS_KEY, all);
}
export function deleteComposition(id) {
  writeJson(COMPS_KEY, loadCompositions().filter((c) => c.id !== id));
}

export function countCardUsage() {
  const usage = {};
  for (const comp of loadCompositions()) {
    for (const c of comp.cards || []) {
      const k = `${c.suit}:${c.index}`;
      usage[k] = (usage[k] || 0) + 1;
    }
  }
  return usage;
}

export function loadTotalSeen() { return readJson(TOTAL_SEEN_KEY, 0); }
export function saveTotalSeen(n) { writeJson(TOTAL_SEEN_KEY, n); }

export function newId() {
  return "c_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
}
export function newInstanceId() {
  return "i_" + Math.random().toString(36).slice(2, 8);
}
